import React from 'react';
import EditServicePage from './EditServicePage';

const DuplicateServicePage: React.FC = () => {
  return <EditServicePage mode="duplicate" />;
};

export default DuplicateServicePage;
